import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../wayfinder'
/**
* @see \App\Http\Controllers\LegalPageController::__invoke
* @see app/Http/Controllers/LegalPageController.php:25
* @route '/legal/{page}'
*/
export const show = (args: { page: string | number } | [page: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/legal/{page}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\LegalPageController::__invoke
* @see app/Http/Controllers/LegalPageController.php:25
* @route '/legal/{page}'
*/
show.url = (args: { page: string | number } | [page: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { page: args }
    }

    if (Array.isArray(args)) {
        args = {
            page: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        page: args.page,
    }

    return show.definition.url
            .replace('{page}', parsedArgs.page.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\LegalPageController::__invoke
* @see app/Http/Controllers/LegalPageController.php:25
* @route '/legal/{page}'
*/
show.get = (args: { page: string | number } | [page: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LegalPageController::__invoke
* @see app/Http/Controllers/LegalPageController.php:25
* @route '/legal/{page}'
*/
show.head = (args: { page: string | number } | [page: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\LegalPageController::__invoke
* @see app/Http/Controllers/LegalPageController.php:25
* @route '/legal/{page}'
*/
const showForm = (args: { page: string | number } | [page: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LegalPageController::__invoke
* @see app/Http/Controllers/LegalPageController.php:25
* @route '/legal/{page}'
*/
showForm.get = (args: { page: string | number } | [page: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LegalPageController::__invoke
* @see app/Http/Controllers/LegalPageController.php:25
* @route '/legal/{page}'
*/
showForm.head = (args: { page: string | number } | [page: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

const legal = {
    show: Object.assign(show, show),
}

export default legal